import { OverlayTrigger } from "react-bootstrap";
import LobbiePopover from "src/components/shared/tooltips/LobbiePopover";
import Bootstrap5Row from "src/components/shared/elements/Bootstrap5Row";
import LobbieHelpIcon from "src/components/shared/tooltips/LobbieHelpIcon";
import { IHelpTooltipProps } from "src/components/shared/tooltips/constants";

const HelpTooltip: React.FC<IHelpTooltipProps> = ({
    message,
    tooltipId,
    title,
    size,
    hideLabel,
    placement,
    containerClassName,
    className,
    popoverStyle,
    delayMilliseconds,
    showTooltipFirst,
    interiorTooltip,
}) => {
    return (
        <div className={containerClassName ?? ""}>
            {!title && (
                <div className={`ms-1 mb-1 ${className}`}>
                    <OverlayTrigger
                        delay={delayMilliseconds}
                        placement={placement || "top"}
                        overlay={<LobbiePopover tooltipId={tooltipId} message={message} />}
                    >
                        <LobbieHelpIcon size={size} />
                    </OverlayTrigger>
                </div>
            )}
            {title && (
                <Bootstrap5Row className={className}>
                    {!hideLabel && !interiorTooltip && !showTooltipFirst && <span>{title}</span>}
                    <div className="ml-1 mb-1">
                        {!hideLabel && interiorTooltip && !showTooltipFirst && <span>{title}</span>}
                        <OverlayTrigger
                            delay={delayMilliseconds}
                            placement={placement || "top"}
                            overlay={
                                <LobbiePopover
                                    tooltipId={tooltipId}
                                    message={message}
                                    title={title}
                                    popoverStyle={popoverStyle}
                                />
                            }
                        >
                            <LobbieHelpIcon size={size} />
                        </OverlayTrigger>
                        {!hideLabel && interiorTooltip && showTooltipFirst && <span>{title}</span>}
                    </div>
                    {!hideLabel && !interiorTooltip && showTooltipFirst && <span>{title}</span>}
                </Bootstrap5Row>
            )}
        </div>
    );
};

export default HelpTooltip;
